import { bunja } from 'bunja';
import { atom } from 'jotai';
import { ReactNode } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { CopyTradingIconography } from '@flipster/react/graphic-assets/iconography/CopyTradingIconography';
import { FastIconography } from '@flipster/react/graphic-assets/iconography/FastIconography';
import { SeamlessIconography } from '@flipster/react/graphic-assets/iconography/SeamlessIconography';
import { SecurityIconography } from '@flipster/react/graphic-assets/iconography/SecurityIconography';
import { TrendingIconography } from '@flipster/react/graphic-assets/iconography/TrendingIconography';
import { TrustedPlatformIconography } from '@flipster/react/graphic-assets/iconography/TrustedPlatformIconography';

import { userRegulationBunja } from '../regulation';

export interface BenefitItemProps {
  id: string;
  iconography: ReactNode;
  title: ReactNode;
  description: ReactNode;
}

export const benefitSectionBunja = bunja(() => {
  const { isSpotOnlyRegulationAtom } = bunja.use(userRegulationBunja);
  const perpBenefitsAtom = atom((): BenefitItemProps[] => {
    return [
      {
        id: 'Copy_master_traders',
        iconography: <CopyTradingIconography size='100%' />,
        title: <FormattedMessage id='Copy.r251217.Copy_master_traders' />,
        description: <FormattedMessage id='Copy.r251217.Follow_top_performers_mirror_strategies' />,
      },
      {
        id: 'Instant_execution',
        iconography: <FastIconography size='100%' />,
        title: <FormattedMessage id='Common.r251107.Instant_execution' />,
        description: <FormattedMessage id='Common.r251107.Trade_perps_with_lightning_fast_fills' />,
      },
      {
        id: 'Earn_while_your_trade',
        iconography: <SeamlessIconography size='100%' />,
        title: <FormattedMessage id='Common.r251107.Earn_while_your_trade' />,
        description: (
          <FormattedMessage id='Common.r251107.Earn_yield_on_symbol_even_as_you_trade' values={{ symbol: 'USDT' }} />
        ),
      },
    ];
  });
  const spotOnlyBenefitsAtom = atom((): BenefitItemProps[] => {
    return [
      {
        id: 'Fast_easy_trading',
        iconography: <TrendingIconography size='100%' />,
        title: <FormattedMessage id='Autogen_common.r251126.s_Fast_easy_trading' />,
        description: <FormattedMessage id='Autogen_common.r251126.s_Buy_and_sell_crypto_in_just_a_few_taps' />,
      },
      {
        id: 'Protected_by_design',
        iconography: <SecurityIconography size='100%' />,
        title: <FormattedMessage id='Autogen_common.r251126.s_Protected_by_design' />,
        description: <FormattedMessage id='Autogen_common.r251126.s_Security_and_compliance_built_into_every_step' />,
      },
      {
        id: 'Trusted_access',
        iconography: <TrustedPlatformIconography size='100%' />,
        title: <FormattedMessage id='Autogen_common.r251126.s_Trusted_access' />,
        description: (
          <FormattedMessage id='Autogen_common.r251126.s_A_platform_you_can_rely_on_wherever_you_are_in_your_crypto_journey' />
        ),
      },
    ];
  });
  const benefitsAtom = atom((get) => {
    if (get(isSpotOnlyRegulationAtom)) return get(spotOnlyBenefitsAtom);
    return get(perpBenefitsAtom);
  });

  return { benefitsAtom };
});
benefitSectionBunja.debugLabel = 'benefitSectionBunja';
